import React, {Component} from 'react';
import IndependentSelector from "../components/Planner/IndependentSelector";
import PropTypes from 'prop-types';
import * as router from '../services/frontendRouter';
import translate from '../services/translation';
import * as api from '../services/api';
import SeasonSingleSelector from "../components/Planner/SeasonSingleSelector";

export class PlannerTeaserApp extends Component {

    static propTypes = {
        linkToPlannerList: PropTypes.string
    };

    initialState = {
        filter: {
            travelAreaCountry: 0,
            travelType: 0,
            year: 0,
            timeOfYear: 0
        },
        types: [],
        years: [],
        countries: [],
    };

    constructor(props) {
        super(props);

        this.fetchOptionsData();

        this.state = this.initialState;
    }

    updateFilter = (event) => {
        let castValue;
        if(Array.isArray(event.target.value)) {
            castValue = event.target.value;
        } else {
            castValue = isNaN(event.target.value) ? event.target.value : parseInt(event.target.value, 10);
        }

        let newFilter;

        if (event.target.hasOwnProperty('timeOfYear')) {
            newFilter = {...this.state.filter, [event.target.name]: castValue, timeOfYear: event.target.timeOfYear};
        } else {
            newFilter = {...this.state.filter, [event.target.name]: castValue};
        }

        this.setState({filter: newFilter});
    };

    redirectToPlannerList = () => {
        const searchParams = router.createSearchParamsFrom(this.state.filter);

        window.location.href = this.props.linkToPlannerList + '?' + searchParams;
    };

    fetchOptionsData = () => {
        this.fetchTravelAreas();
        this.fetchTags('ItineraryLabelsKontiki', 'labels');
        this.fetchTags('ItineraryTypeKontiki', 'types');
        this.fetchOptions('seasons', 'years');
    };

    fetchTags = (clvType, stateField) => {
        api.getTagsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    };

    fetchOptions = (clvType, stateField) => {
        api.getOptionsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    };

    fetchTravelAreas = () => {
        api.getTravelAreasByDepth(2).then(
            response => {
                this.setState({countries: response.data})
            }
        )
    };

    render() {
        const {filter, countries, types, years} = this.state;

        return (
            <div className={'plannerTeaserAppContainer'}>
                <IndependentSelector name="travelAreaCountry"
                                     selectedOption={filter.travelAreaCountry}
                                     options={countries}
                                     defaultOptionLabel={translate('planner_list.choose_country')}
                                     onChange={this.updateFilter}
                                     hasSpecialIcon={true}
                />
                <IndependentSelector name="travelType"
                                     selectedOption={filter.travelType}
                                     options={types}
                                     defaultOptionLabel={translate('planner_list.choose_type')}
                                     onChange={this.updateFilter}
                                     hasSpecialIcon={true}
                />

                <SeasonSingleSelector name="year"
                                      defaultOptionLabel={translate('planner_list.choose_season')}
                                      years={years}
                                      selectedYear={filter.year}
                                      timeOfYear={filter.timeOfYear}
                                      onChange={this.updateFilter}
                                      hasSpecialIcon={true}
                />

                <button onClick={this.redirectToPlannerList}>
                    {translate('planner_teaser.find_button')}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/apps/PlannerTeaserApp.js